/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResponseStyleType {
    Standard = 'Standard',
    Texas = 'Texas',
    Simple = 'Simple'
}

export function ResponseStyleTypeFromJSON(json: any): ResponseStyleType {
    return ResponseStyleTypeFromJSONTyped(json, false);
}

export function ResponseStyleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStyleType {
    return json as ResponseStyleType;
}

export function ResponseStyleTypeToJSON(value?: ResponseStyleType | null): any {
    return value as any;
}

